export const environment = {
  production: true,
  FRONTEND_BASE_URL: "https://portal.nowaschools.org/",
  BASE_URL: "https://portalapi.nowaschools.org",
  TRANZGATE_URL: "https://pay.tranzgate.com.ng/",

  logo: "/assets/logos/nowa-logo.png",
  short_name: "NOWA",
  long_name: "Naval Officers' Wives Association Group of Schools",

  nav_links: {
    home: true,
    biodata: true,
    payment: true,
    course: true,
    result: true,
    appointment: true,
    election: true,
    accommodation: true,
    application: true,
    purchases: true,
  },

  remita: false,
  allowedCompanies: [] as string[],
};
